<!--<label for="otpEmail">OTP Email:</label>
<input class="form-control" type="email" id="otpEmail" name="otpEmail" required>-->
<!--<button class="btn btn-primary full-width" (click)="save()">{{ 'common.save' | translate }}</button>-->
<!--<button class="btn btn-primary full-width" (click)="save()">Save</button>

<div class="mb-3">
  <label for="email" class="form-label">Email address</label>
  <input type="email" class="form-control" id="email" placeholder="name@example.com" required>
</div>-->

<div class="container d-flex justify-content-center align-items-center min-vh-100">
  <div class="card shadow-lg p-4" style="max-width: 500px; width: 100%;">

    <h4 class="mb-3 text-center">{{ 'sideMenu.mfa' | translate }}</h4>

    <!-- Form -->
    <form class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="email" class="form-label">Email Address</label>
        <input type="email" class="form-control" id="email" name="email" [(ngModel)]="email"
               placeholder="name@example.com" required>
      </div>

      <div class="d-grid">
        <button type="button" class="btn btn-primary" (click)="save()">
          Save
        </button>
      </div>
      <div *ngIf="isSuccess">{{ 'sideMenu.mfa_success' | translate }}</div>

    </form>
  </div>
</div>
